/**
 * The words of the phone system's three web pages (decision 11860; row T3708's web half): Calls, Voicemail and Texts
 * with its thread, spread into the one string lookup.
 */
export const PHONE_PAGES_STRINGS = {
  'phonePages.calls.title': 'Calls',
  'phonePages.calls.subtitle': 'Every call you can read on the organization’s numbers, newest first',
  'phonePages.calls.empty': 'No calls yet.',
  'phonePages.calls.sortLocked': 'Calls read newest first.',
  'phonePages.calls.export': 'Export',
  'phonePages.calls.exportFailed': 'The calls could not be read for the export. Try again.',
  'phonePages.voicemail.title': 'Voicemail',
  'phonePages.voicemail.subtitle': 'The messages left on the numbers you read, newest first',
  'phonePages.voicemail.empty': 'No voicemail yet.',
  'phonePages.voicemail.play': 'Play',
  'phonePages.voicemail.noRecording': 'No recording',
  'phonePages.voicemail.done': 'Done',
  'phonePages.voicemail.completed': 'The to-do is done.',
  'phonePages.voicemail.noTranscript': 'No transcript yet.',
  'phonePages.texts.title': 'Texts',
  'phonePages.texts.subtitle': 'One row per conversation on the numbers you read',
  'phonePages.texts.empty': 'No texts yet.',
  'phonePages.texts.threadSubtitle': 'A conversation on one of the organization’s numbers',
  'phonePages.texts.back': 'All Texts',
  'phonePages.texts.on': 'On',
  'phonePages.texts.companyNumber': 'The company number',
  'phonePages.texts.unknown': 'No Person holds this number.',
  'phonePages.texts.createLead': 'Create Lead',
  'phonePages.texts.leadMade': 'The Lead was made.',
  'phonePages.texts.noReply': 'A reply is sent once a Person holds this number and a text service is connected.',
  'phonePages.col.direction': 'Direction',
  'phonePages.col.theirNumber': 'Number',
  'phonePages.col.ourNumber': 'Our Number',
  'phonePages.col.record': 'Record',
  'phonePages.col.time': 'Time',
  'phonePages.col.length': 'Length',
  'phonePages.col.status': 'Status',
  'phonePages.col.transcript': 'Transcript',
  'phonePages.col.latest': 'Latest',
  'phonePages.col.person': 'Person',
  'phonePages.col.unanswered': 'Unanswered',
  'phonePages.direction.inbound': 'Inbound',
  'phonePages.direction.outbound': 'Outbound',
  'phonePages.filter.status': 'Status',
  'phonePages.filter.number': 'Our Number',
  'phonePages.filter.any': 'Any',
  'phonePages.filter.from': 'From',
  'phonePages.filter.to': 'To',
  'phonePages.filter.general': 'General',
  'phonePages.filter.rep': 'Rep',
  'phonePages.status.placing': 'Placing',
  'phonePages.status.ringing': 'Ringing',
  'phonePages.status.inProgress': 'In Progress',
  'phonePages.status.completed': 'Completed',
  'phonePages.status.noAnswer': 'No Answer',
  'phonePages.status.busy': 'Busy',
  'phonePages.status.failed': 'Failed',
  'phonePages.status.missed': 'Missed',
  'phonePages.status.voicemail': 'Voicemail',
  'phonePages.window.title': 'Call',
  'phonePages.window.from': 'From',
  'phonePages.window.to': 'To',
  'phonePages.window.started': 'Started',
  'phonePages.window.ended': 'Ended',
  'phonePages.window.length': 'Length',
  'phonePages.window.record': 'Record',
  'phonePages.window.transcript': 'Transcript',
  'phonePages.window.close': 'Close',
  'phonePages.unknownCaller': 'Unknown caller',
} as const;
